export const trackEvent = (name, params = {}) => {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  }
  if (window.dataLayer) {
    window.dataLayer.push({ event: name, ...params });
  }
};
